export const BRANCH_STORAGE_KEY = 'saloon_erp_active_branch_id'

/**
 * @returns {number | null}
 */
export function getStoredBranchId() {
  if (typeof localStorage === 'undefined') {
    return null
  }

  const raw = localStorage.getItem(BRANCH_STORAGE_KEY)
  if (!raw) {
    return null
  }

  const id = Number(raw)
  return Number.isFinite(id) ? id : null
}

/**
 * @param {number} id
 */
export function storeBranchId(id) {
  if (typeof localStorage !== 'undefined') {
    localStorage.setItem(BRANCH_STORAGE_KEY, String(id))
  }
}

export function clearStoredBranchId() {
  if (typeof localStorage !== 'undefined') {
    localStorage.removeItem(BRANCH_STORAGE_KEY)
  }
}

/**
 * @param {import('@/types/api').AuthUser | null | undefined} user
 * @param {number | null | undefined} [storedId]
 * @returns {number | null}
 */
export function resolveInitialBranchId(user, storedId = getStoredBranchId()) {
  if (!user) {
    return null
  }

  const accessible = user.branches?.map((branch) => branch.id) ?? []

  if (storedId && accessible.includes(storedId)) {
    return storedId
  }

  const defaultId = user.default_branch?.id
  if (defaultId && accessible.includes(defaultId)) {
    return defaultId
  }

  return accessible[0] ?? null
}
